import { ApplicationStore } from "src/store";
import { isLockedPricingSetup } from "src/store/selectors/account";

export const shouldCleanUpVehiclesOnOpen = (state: ApplicationStore) => {
    return (
        !state.onlineShopper.isAuthed ||
        (isLockedPricingSetup(state) && state.onlineShopper.isAuthed && !state.onlineShopper.garageCreated)
    );
};
